import { Checkbox, CheckboxProps } from "@mui/material";

export const SHCheckbox = (props: CheckboxProps): JSX.Element => (
  <Checkbox {...props} />
);
